export enum ErrorMessage {
  LOAD = 'Unable to load data',
}
